@if (configActive$ | async) {
<ng-container [ngTemplateOutlet]="proxyContent"></ng-container>
} @else {
<ng-container *ngIf="redirectOnDeactivated">
  <div
    fxFlex
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="0.5rem"
    style="text-align: center; padding: 1rem">
    <h3>Hier gibt es noch nichts zu sehen</h3>
    <button mat-raised-button color="primary" (click)="toRedirect()">Zurück zur Startseite</button>
  </div>
</ng-container>
}
